import { useSelector } from "react-redux";
import { notifyAllActiveProcesses, selectNewUpdate } from "./BackgroundActivitySlice";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faWavePulse } from "@fortawesome/pro-solid-svg-icons";
import { Link } from "react-router-dom";
import { useEffect } from "react";
import { useThunkDispatch } from "setup/redux/thunkDispatch";

const BackgroundActivityBadge: React.FC = () => {
  const newUpdate = useSelector(selectNewUpdate);
  const thunkDispatch = useThunkDispatch();

  useEffect(() => {
    thunkDispatch(notifyAllActiveProcesses());
  }, [thunkDispatch]);

  return (
    <Link
      data-test-id="navbar__open-background-activities-link"
      to={"/BackgroundActivities"}
      className="btn btn-icon pulse pulse-primary"
    >
      <FontAwesomeIcon icon={faWavePulse} size="xl" />
      {newUpdate && <span className="pulse-ring"></span>}
    </Link>
  );
};

export default BackgroundActivityBadge;
